import PhotoPositionIndicator from '../src/PhotoPositionIndicator.tsx';
export default PhotoPositionIndicator;
